import { Component, inject } from '@angular/core';
import { ToastType } from 'app/models/toast.model';
import { ToastService } from 'app/services/toast.service';
import { SvgIconComponent } from 'angular-svg-icon';

@Component({
  selector: 'app-toast',
  imports: [SvgIconComponent],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss',
})
export class ToastComponent {
  private toastService = inject(ToastService);
  public queue = this.toastService.queue;
  public ToastType = ToastType;
  public removeToast(id: string) {
    this.toastService.removeToast(id);
  }
}
